import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { MailWarning, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export function VerifyEmailBanner() {
  const { user, api } = useAuth();
  const [sending, setSending] = useState(false);
  const [hidden, setHidden] = useState(false);
  if (!user || user.email_verified !== false || hidden) return null;

  const resend = async () => {
    setSending(true);
    try {
      const { data } = await api.post('/api/auth/resend-verification');
      toast.success(data.message);
      if (data.already_verified) setHidden(true);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Could not send verification email');
    }
    setSending(false);
  };

  return (
    <div
      className="mx-4 mt-4 sm:mx-6 lg:mx-8 flex flex-col sm:flex-row sm:items-center gap-3 rounded-lg border border-[#FFEA00]/30 bg-[#FFEA00]/10 px-4 py-3"
      data-testid="verify-email-banner"
    >
      <MailWarning className="w-5 h-5 text-[#FFEA00] shrink-0" />
      <p className="text-sm text-[#E6EEF8] flex-1">
        Please confirm <span className="font-semibold">{user.email}</span> to keep receiving account updates and offers.
      </p>
      <button
        onClick={resend}
        disabled={sending}
        className="text-sm font-semibold text-[#000B18] bg-[#FFEA00] hover:bg-[#FFF176] transition-colors rounded-full px-4 py-1.5 disabled:opacity-60 flex items-center gap-2"
        data-testid="verify-email-resend-btn"
      >
        {sending && <Loader2 className="w-4 h-4 animate-spin" />}
        Resend link
      </button>
    </div>
  );
}
